"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Ref, Component } from "vue-property-decorator";
import { GeneralGridResult, GeneralSearchQuery } from "../grid/core";
import { APIDataSource } from "../grid/data-source";
import { VirtualDesktopItemColumn } from "./item";
import { ControllerComponent } from "@/components/core";
import _ from "lodash";
import { AccountSessionStorage } from "@/service/account-session";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import DateFormat from "@/framework/timeformatter";
import RemoteVDDialog from "@/views/virtualdesktopItems/components/dialog-forms/RemoteVDDialog.vue";
import { TimerEngine } from "@/utils/settimeout";
export class VirtualDesktopContentController {
  constructor() {
    // base.auth.pro
    // VD列表
    // dataSource = new APIDataSource<VirtualDesktopItemColumn, VirtualdesktopModel>(
    this.dataSource = new APIDataSource(
      // "api://base.auth/api/v9/virtual_desktops",
      // "api://base.auth.kv.vd/v1/virtualdesktops",
      "api://base.auth.pro/v1/virtual-desktops",
      {
        factory: (item) => {
          return VirtualDesktopItemColumn.create(item);
        }
      }
    );
    this._gridResult = new GeneralGridResult();
    this._query = new GeneralSearchQuery();
    this._loading = false;
    this._mode = "items";
    // protected _onlineService: Optional<OnlineService> = null;
    this._select = [];
  }
  search() {
    return __async(this, null, function* () {
      this._loading = true;
      let _query = __spreadValues({}, this.query);
      _query.params = __spreadProps(__spreadValues({}, _query.params), { type: "ALL" });
      _query.filter = ((obj) => {
        let str = "";
        str = "hide==false;";
        for (const prop in obj) {
          if (Array.isArray(this._query.filter[prop])) {
            if (!this._query.filter[prop].length) {
              continue;
            }
            if (prop === "expiryDate") {
              continue;
            }
            if (prop === "platform") {
              let substr = `${prop}=in=(`;
              this._query.filter[prop] = this._query.filter[prop].map(
                (item) => {
                  return `${item}`;
                }
              );
              substr += this._query.filter[prop].join(",");
              str += `${substr});`;
              continue;
            }
            str += `${this._query.filter[prop][0]}=sort=${this._query.filter[prop][1]};`;
          } else {
            if (this._query.filter[prop] === null || this._query.filter[prop] === "") {
              continue;
            }
            if (prop === "autoRenew" && obj[prop] === "ALL") {
              continue;
            }
            if (prop === "name") {
              str += `${prop}=like="${obj[prop]}";`;
            } else if (prop === "expiredTimeStart") {
              str += `${prop}>=${obj[prop]};`;
            } else if (prop === "expiredTimeEnd") {
              str += `${prop}<=${obj[prop]};`;
            } else {
              str += `${prop}==${obj[prop]};`;
            }
          }
        }
        return str;
      })(_query.filter);
      if (_query.sort) {
        if (_query.sort === "lastVisit,asc") {
          _query.filter = _query.filter + "lastVisit=sort=asc;";
        }
        if (_query.sort === "lastVisit,desc") {
          _query.filter = _query.filter + "lastVisit=sort=desc;";
        }
        if (_query.sort === "expiredTime,asc") {
          _query.filter = _query.filter + "expiredTime=sort=asc;";
        }
        if (_query.sort === "expiredTime,desc") {
          _query.filter = _query.filter + "expiredTime=sort=desc;";
        }
        if (_query.sort === "name,asc") {
          _query.filter = _query.filter + "name=sort=asc;";
        }
        if (_query.sort === "name,desc") {
          _query.filter = _query.filter + "name=sort=desc;";
        }
        if (_query.sort === "admins,desc") {
          _query.filter = _query.filter + "admins=sort=desc;";
        }
        if (_query.sort === "admins,asc") {
          _query.filter = _query.filter + "admins=sort=asc;";
        }
        if (_query.filter.indexOf("vdgroup_system_lately") !== -1) {
          if (_query.sort === "createdTime,desc") {
            _query.filter = _query.filter + "latelyTime=sort=desc;";
          }
          if (_query.sort === "createdTime,asc") {
            _query.filter = _query.filter + "latelyTime=sort=desc;";
          }
        } else {
          if (_query.sort === "createdTime,desc") {
            _query.filter = _query.filter + "createdTime=sort=desc;";
          }
          if (_query.sort === "createdTime,asc") {
            _query.filter = _query.filter + "createdTime=sort=asc;";
          }
        }
      }
      const _datas = yield this.dataSource.search(_query);
      this._gridResult = _datas;
      this._loading = false;
    });
  }
  result() {
    return this._gridResult;
  }
  get loading() {
    return this._loading;
  }
  get mode() {
    return this._mode;
  }
  set mode(mode) {
    this._mode = mode;
  }
  get query() {
    return this._query;
  }
  get selected() {
    return this._select;
  }
  // public get onlineService() {
  //   if (this._onlineService === null) {
  //     this._onlineService = new OnlineService("vd");
  //   }
  //   return this._onlineService;
  // }
}
let VirtualDesktopContent = class extends ControllerComponent {
  constructor() {
    super(...arguments);
    //websocketService服务实现
    this.webSocketService = WebsocketViewService;
    //轮询视图控制器
    this.view_listener = null;
  }
  created() {
    return __async(this, null, function* () {
      if (localStorage.getItem("vd_mode") !== null && localStorage.getItem("vd_mode") !== "") {
        this.$controller.mode = localStorage.getItem("vd_mode");
      }
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield Promise.all([
        this.setupWebSocketListeners(),
        this.initializeData()
      ]);
    });
  }
  setupWebSocketListeners() {
    return __async(this, null, function* () {
      const ipcEvent = this.webSocketService._ipcEvent;
      ipcEvent.on("event:clientEvent.subBrowser.launch", (data) => __async(this, null, function* () {
        const _item = _.find(this.$controller.result().datas, {
          oldId: data.data.extra.vd_id
        });
        if (_item) {
          const _timeout = setTimeout(() => {
            _item.runtime.status = "ready";
          }, 1e3);
        }
      }));
      ipcEvent.on("event:clientEvent.process.launch", (data) => __async(this, null, function* () {
        const _item = _.find(this.$controller.result().datas, {
          oldId: data.data.extra.id
        });
        if (_item) {
          const _timeout = setTimeout(() => {
            _item.remote_runtime.status = "ready";
          }, 1e3);
        }
      }));
      ipcEvent.on("event:clientEvent.subBrowser.launch.error", (data) => __async(this, null, function* () {
        yield this.manageError(data);
      }));
      ipcEvent.on("event:clientEvent.remote.launcher.error", (data) => __async(this, null, function* () {
        yield this.remoteError(data);
      }));
      ipcEvent.on("event:clientEvent.subBrowser.launch.progress", (data) => __async(this, null, function* () {
        const _item = _.find(this.$controller.result().datas, {
          id: data.data.new_vd
        });
        if (_item) {
          _item.launcher_progress = data.data.progress;
          if (_item.launcher_progress === 100) {
            const _timeout = setTimeout(() => {
              _item.launcher_progress = 0;
              _item.runtime.status = "ready";
            }, 1e3);
          }
        }
      }));
      ipcEvent.on("event:clientEvent.remote.launcher.progress", (data) => __async(this, null, function* () {
        const _item = _.find(this.$controller.result().datas, {
          oldId: data.data.vd_id
        });
        if (_item) {
          _item.remote_launcher_progress = data.data.progress;
          if (_item.remote_launcher_progress === 100) {
            const _timeout = setTimeout(() => {
              _item.remote_launcher_progress = 0;
              _item.remote_runtime.status = "ready";
            }, 1e3);
          }
        }
      }));
    });
  }
  initializeData() {
    return __async(this, null, function* () {
      try {
        yield this.getView();
      } catch (error) {
        console.error("Failed to initialize data:", error);
      }
    });
  }
  getView() {
    return __async(this, null, function* () {
      this.view_listener = new TimerEngine(() => __async(this, null, function* () {
        try {
          let datas = [];
          for (let item of this.$controller.result().datas) {
            let shopIds = _.map(item.shops, "oldId");
            let vditem = {
              vdId: item.oldId,
              shopIds
            };
            datas.push(vditem);
          }
          let response = yield API.post(
            `api://base.auth.view/api/v1/online-users/vd`,
            {
              datas
            }
          );
          for (const _item of response.data.datas) {
            const _column = _.find(this.$controller.result().datas, {
              oldId: _item.vdId
            });
            if (_column) {
              let _onLineList = {
                total: _item.users.length,
                datas: _item.users
              };
              _column.onLineList = _onLineList;
            }
          }
        } catch (error) {
        }
      }), 2e4);
      this.view_listener.start();
    });
  }
  remoteError(data) {
    return __async(this, null, function* () {
      var _a;
      const _item = _.find(this.$controller.result().datas, {
        oldId: data.data.vd_id
      });
      if (_item) {
        const _timeout = setTimeout(() => {
          _item.runtime.status = "ready";
        }, 1e3);
      }
      if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.vd") {
        try {
          let account = data.message.errors.datas[0].account;
          let start_time = data.message.errors.datas[0].start_time;
          let date = this.format_date(start_time);
          if (account === null || account === "" || account === void 0) {
            account = {
              name: ""
            };
          }
          let account_no = data.message.errors.datas[0].account_no;
          if (account_no === "" || account_no === null) {
            let _data2 = {
              name: account.name,
              device_mini: "-",
              ip: "-",
              date
            };
            this.remote_vd_dialog.open(_data2);
            return;
          }
          let response = yield API.get(
            `api://base.auth/api/v7_1/account/lock/${account_no}`
          );
          let _data = {
            name: response.data.name,
            device_mini: response.data.device_mini,
            ip: response.data.ip,
            date
          };
          this.remote_vd_dialog.open(_data);
        } catch (error) {
          _item.runtime.status = "ready";
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.shop") {
        if (((_a = AccountSessionStorage.getSession()) == null ? void 0 : _a.type) === "user" && !AccountSessionStorage.getSession().permissions.is("SHOW_ALL_MENUS")) {
          this.$message.error(this.$t("shop.user_lock_error_message"));
        }
      } else {
        if (data.data.error.hasOwnProperty("errors") && data.data.error.errors !== void 0) {
          this.$message.error(data.data.error.errors.datas[0].message);
        }
      }
    });
  }
  /**
   * 判断是否为cookie失效导致的错误
   * @param error 错误对象
   * @returns 是否为cookie失效
   */
  isCookieExpired(error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 401 || ((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) === 403) {
      return true;
    }
    if (((_g = (_f = (_e = (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.errors) == null ? void 0 : _e.datas) == null ? void 0 : _f[0]) == null ? void 0 : _g.code) === "token.error" || ((_j = (_i = (_h = error == null ? void 0 : error.errors) == null ? void 0 : _h.datas) == null ? void 0 : _i[0]) == null ? void 0 : _j.code) === "token.error") {
      return true;
    }
    if ((error == null ? void 0 : error.hasOwnProperty("response")) && (((_k = error.response) == null ? void 0 : _k.status) === 401 || ((_l = error.response) == null ? void 0 : _l.status) === 403)) {
      return true;
    }
    return false;
  }
  manageError(data) {
    return __async(this, null, function* () {
      var _a, _b;
      const _item = _.find(this.$controller.result().datas, {
        oldId: data.data.vd_id
      });
      if (_item) {
        const _timeout = setTimeout(() => {
          _item.runtime.status = "ready";
        }, 1e3);
      }
      if (this.isCookieExpired(data.data.error)) {
        this.$message.error(
          this.$t("main.shop_launch_cookie_expired")
        );
        return;
      }
      if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.vd") {
        if (((_a = AccountSessionStorage.getSession()) == null ? void 0 : _a.type) === "user") {
          this.$message.error(this.$t("vd.user_lock_error_message"));
        } else {
          this.$message.error(this.$t("vd.account_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "lock.shop") {
        if (((_b = AccountSessionStorage.getSession()) == null ? void 0 : _b.type) === "user" && !AccountSessionStorage.getSession().permissions.is("SHOW_ALL_MENUS")) {
          this.$message.error(this.$t("shop.user_lock_error_message"));
        } else {
          this.$message.error(this.$t("shop.account_lock_error_message"));
        }
      } else if (data.data.error.hasOwnProperty("errors") && data.data.error.errors.datas[0].code === "browser") {
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              new_vd: data.data.new_vd,
              shop_id: data.data.id,
              new_shop_id: data.data.new_shop_id
            }
          });
          let flag = true;
          try {
            yield API.get(`api://base.local/storages/preference/mainExtensionVersion`);
            flag = true;
          } catch (error) {
            flag = false;
          }
          if (flag) {
            yield API.post(`api://base.local/websockets/main`, {
              "model": "virtualBrowser.launcher_new",
              "value": {
                shop_id: data.data.id,
                new_shop_id: data.data.new_shop_id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd
              }
            });
          } else {
            yield API.post(`api://base.local/websockets/main`, {
              "model": "virtualBrowser.launcher",
              "value": {
                shop_id: data.data.id,
                new_shop_id: data.data.new_shop_id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd
              }
            });
          }
        } else if (time !== null && Number(time) < 3) {
          time = (Number(time) + 1).toString();
          sessionStorage.setItem("browser_retry_times", time);
          this.$message.info(
            this.$t("main.shop_launch_browser_error_info")
          );
          let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
          let code = env_response.data.appData.browser.code;
          let version = env_response.data.appData.browser.version;
          yield API.delete(
            `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
          );
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
        } else {
          if (this.isCookieExpired(data.data.error)) {
            this.$message.error(
              this.$t("main.shop_launch_cookie_expired")
            );
          } else {
            this.$message.info(
              this.$t("main.shop_launch_browser_error_message")
            );
          }
        }
      } else if (data.data.error.hasOwnProperty("response")) {
        if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser.resource.not.exist") {
          const h2 = this.$createElement;
          if (data.data.error.browser_core === "firefox") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t("main.shop_visit_browser_firefox_resorce_tip")
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else if (data.data.error.browser_core === "chrome") {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t("main.shop_visit_browser_chrome_resorce_tip")
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          } else {
            yield UiConfirm.confirm(
              "",
              this.$t("main.shop_visit_browser_resorce_title"),
              {
                message: h2("div", void 0, [
                  h2(
                    "p",
                    void 0,
                    this.$t("main.shop_visit_browser_resorce_tip")
                  )
                ]),
                confirmButtonText: this.$t("main.confirm"),
                cancelButtonText: this.$t("main.cancel")
              }
            );
          }
        } else if (data.data.error.response.data.hasOwnProperty("errors") && data.data.error.response.data.errors.datas[0].code === "browser") {
          let time = sessionStorage.getItem("browser_retry_times");
          if (time === null) {
            time = "1";
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
            let flag = true;
            try {
              yield API.get(`api://base.local/storages/preference/mainExtensionVersion`);
              flag = true;
            } catch (error) {
              flag = false;
            }
            if (flag) {
              yield API.post(`api://base.local/websockets/main`, {
                "model": "virtualBrowser.launcher_new",
                "value": {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } else {
              yield API.post(`api://base.local/websockets/main`, {
                "model": "virtualBrowser.launcher",
                "value": {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            }
          } else if (time !== null && Number(time) < 3) {
            time = (Number(time) + 1).toString();
            sessionStorage.setItem("browser_retry_times", time);
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            yield API.delete(
              `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
            );
            yield API.post(`api://base.local/websockets/view`, {
              model: "virtualbrowser.launcher.restart",
              value: {
                vd_guid: data.data.vd_id,
                shop_id: data.data.id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
            yield API.post(`api://base.local/websockets/main`, {
              "model": "virtualBrowser.launcher_new",
              "value": {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } else {
            if (this.isCookieExpired(data.data.error)) {
              this.$message.error(
                this.$t("main.shop_launch_cookie_expired")
              );
            } else {
              this.$message.info(
                this.$t("main.shop_launch_browser_error_message")
              );
            }
          }
        } else if (data.data.error.code === "ERR_BAD_REQUEST") {
          console.log(data);
          try {
            this.$message.info(
              this.$t("main.shop_launch_browser_error_info")
            );
            let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
            let code = env_response.data.appData.browser.code;
            let version = env_response.data.appData.browser.version;
            let time = sessionStorage.getItem("browser_retry_times");
            if (time === null) {
              time = "1";
              sessionStorage.setItem("browser_retry_times", time);
              yield API.delete(
                `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
              );
              yield API.post(`api://base.local/websockets/view`, {
                model: "virtualbrowser.launcher.restart",
                value: {
                  vd_guid: data.data.vd_id,
                  shop_id: data.data.id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
              yield API.post(`api://base.local/websockets/main`, {
                "model": "virtualBrowser.launcher_new",
                "value": {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } else if (time !== null && Number(time) < 3) {
              time = (Number(time) + 1).toString();
              sessionStorage.setItem("browser_retry_times", time);
              yield API.delete(
                `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
              );
              yield API.post(`api://base.local/websockets/view`, {
                model: "virtualbrowser.launcher.restart",
                value: {
                  vd_guid: data.data.vd_id,
                  shop_id: data.data.id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
              yield API.post(`api://base.local/websockets/main`, {
                "model": "virtualBrowser.launcher_new",
                "value": {
                  shop_id: data.data.id,
                  vd_id: data.data.vd_id,
                  new_vd: data.data.new_vd,
                  new_shop_id: data.data.new_shop_id
                }
              });
            } else {
              if (this.isCookieExpired(data.data.error)) {
                this.$message.error(
                  this.$t("main.shop_launch_cookie_expired")
                );
              } else {
                this.$message.error(
                  this.$t("main.shop_launch_browser_error_message")
                );
              }
            }
          } catch (error) {
            if (this.isCookieExpired(data.data.error)) {
              this.$message.error(
                this.$t("main.shop_launch_cookie_expired")
              );
            } else {
              this.$message.error(
                this.$t("main.shop_launch_browser_error_message")
              );
            }
          }
        }
      } else if (data.data.error.hasOwnProperty("message") && data.data.error.message === "upgrade Browser Core") {
      } else if (data.data.error.code === "ERR_BAD_REQUEST") {
        console.log(data);
        let env_response = yield API.get(`api://base.auth.pro/v1/shops/${data.data.new_shop_id}/environment`);
        let code = env_response.data.appData.browser.code;
        let version = env_response.data.appData.browser.version;
        yield API.delete(
          `api://base.local/v2/dynamic-browsers/private/brands/${code}/versions/${version}`
        );
        let time = sessionStorage.getItem("browser_retry_times");
        if (time === null) {
          time = "1";
          sessionStorage.setItem("browser_retry_times", time);
          yield API.post(`api://base.local/websockets/view`, {
            model: "virtualbrowser.launcher.restart",
            value: {
              vd_guid: data.data.vd_id,
              shop_id: data.data.id,
              new_vd: data.data.new_vd,
              new_shop_id: data.data.new_shop_id
            }
          });
          let flag = true;
          try {
            yield API.get(`api://base.local/storages/preference/mainExtensionVersion`);
            flag = true;
          } catch (error) {
            flag = false;
          }
          if (flag) {
            yield API.post(`api://base.local/websockets/main`, {
              "model": "virtualBrowser.launcher_new",
              "value": {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          } else {
            yield API.post(`api://base.local/websockets/main`, {
              "model": "virtualBrowser.launcher",
              "value": {
                shop_id: data.data.id,
                vd_id: data.data.vd_id,
                new_vd: data.data.new_vd,
                new_shop_id: data.data.new_shop_id
              }
            });
          }
          this.$message.error(this.$t("main.shop_launcher_loading"));
        } else {
        }
      } else if (data.data.error.code === "ERR_DISK_ROOM_NOT_ENOUGH") {
        yield UiConfirm.warnconfirm(this.$t("main.shop_launcher_disk_room_not_enough"), this.$t("main.shop_launcher_disk_room_not_enough_title"), {
          confirmButtonText: this.$t("main.confirm"),
          showCancelButton: false,
          iconClass: "el-icon-warning"
        });
      } else {
        console.log(data);
        if (this.isCookieExpired(data.data.error)) {
          this.$message.error(
            this.$t("main.shop_launch_cookie_expired")
          );
        } else {
          this.$message.error(
            this.$t("main.shop_launch_browser_error_message")
          );
        }
      }
    });
  }
  //换页
  currentChange(current) {
    this.$emit("pageChange", current);
    localStorage.setItem("vd.page", current.toString());
    this._controller.query.current = current;
    this.$controller.search();
  }
  //每页显示数量切换
  sizeChange(size) {
    this.$emit("sizeChange", size);
    localStorage.setItem("vd.size", size.toString());
    localStorage.setItem("vd.page", "1");
    this._controller.query.size = size;
    this._controller.query.current = 1;
    this.$controller.search();
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
  //前往帮助
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
  //Vue自带方法 页面销毁之前进行调用
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
    if (this.view_listener !== null) {
      this.view_listener.stop();
    }
  }
};
__decorateClass([
  Ref("remote-vd-dialog")
], VirtualDesktopContent.prototype, "remote_vd_dialog", 2);
__decorateClass([
  Debounce(600)
], VirtualDesktopContent.prototype, "remoteError", 1);
__decorateClass([
  Debounce(600)
], VirtualDesktopContent.prototype, "manageError", 1);
VirtualDesktopContent = __decorateClass([
  Component({
    components: {
      RemoteVDDialog
    }
  })
], VirtualDesktopContent);
export {
  VirtualDesktopContent as default
};
